// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
  position: relative;
}

.search-wrapper {
  top: -0.25rem;
}

input:focus {
  box-shadow: unset;
}

.error-result {
  display: inline-block;
  position: absolute;
  top: 2.25rem;
  left: 0;
  z-index: 3;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  width: 13.25rem;
  color: #6c757d;
  box-shadow: 0rem 0.125rem 0.3125rem -0.25rem rgba(0, 0, 0, 0.75);
  font-size: 0.875rem;
}
.error-result .error-result-inner {
  border: 1px solid #e84e25;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
}
.error-result p {
  color: #e84e25;
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/search/search.component.scss","webpack://./src/assets/styles/variables.scss"],"names":[],"mappings":"AAGA;EACE,qBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,UAAA;EACA,sBCXM;EDYN,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,cCRS;EDWT,gEAAA;EACA,mBAAA;AAFF;AAIE;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;AAFJ;AAKE;EACE,cCjCE;EDkCF,gBAAA;AAHJ","sourcesContent":["@import 'variables';\n@import 'functions';\n\n:host {\n  display: inline-block;\n  position: relative;\n}\n\n.search-wrapper {\n  top: -0.25rem;\n}\n\ninput:focus {\n  box-shadow: unset;\n}\n\n.error-result {\n  display: inline-block;\n  position: absolute;\n  top: rem(36);\n  left: 0;\n  z-index: 3;\n  background-color: $white;\n  border: 1px solid $gray-300;\n  border-radius: rem(4);\n  width: rem(212);\n  color: $gray-600;\n  -webkit-box-shadow: rem(0) rem(2) rem(5) rem(-4) rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: rem(0) rem(2) rem(5) rem(-4) rgba(0, 0, 0, 0.75);\n  box-shadow: rem(0) rem(2) rem(5) rem(-4) rgba(0, 0, 0, 0.75);\n  font-size: rem(14);\n\n  .error-result-inner {\n    border: 1px solid $red;\n    padding: rem(2) rem(6);\n    border-radius: rem(4);\n  }\n\n  p {\n    color: $red;\n    margin-bottom: 0;\n  }\n}\n","@import './functions.scss';\n\n$standard-blue: #54b0cb;\n$dark-blue: #456c9b;\n$green: #6fa163;\n$yellow: #f6af0b;\n$red: #e84e25;\n$min-contrast-ratio: 3;\n\n$enable-validation-icons: false;\n\n$white: #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-550: #8d959d;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black: #000 !default;\n\n$bg-color: #778899;\n$primary: $dark-blue;\n$secondary: $standard-blue;\n$body-color: $gray-600;\n$light: $gray-300;\n$text-muted: $gray-550;\n\n$h1-font-size: rem(28);\n$h2-font-size: rem(24);\n$h3-font-size: rem(19);\n\n$input-btn-padding-y: 0.1875rem;\n$input-btn-padding-x: 0.375rem;\n$input-color: $gray-600;\n$input-placeholder-color: $gray-500;\n\n$grid-gutter-width: 12px;\n$border-color: $gray-200;\n\n// table\n$table-cell-padding: 0.625rem;\n\n$banner-height: rem(60);\n\n@import '../../../node_modules/bootstrap/scss/_functions';\n@import '../../../node_modules/bootstrap/scss/_variables';\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
